import { Bookmark, BookmarkCheck, Copy, Play, Repeat, Share2 } from 'lucide-react';
import { useProgress } from '@/lib/store';
import { usePlayer } from '@/features/player/audioEngine';
import { useSettings } from '@/lib/store';
import { Row, Section, Sheet } from '@/components/ui';
import { chapter, parseKey } from './api';

export function AyahSheet({ verseKey, text, onClose }: { verseKey: string | null; text?: string; onClose: () => void }) {
  const bookmarked = useProgress((s) => (verseKey ? !!s.bookmarks[verseKey] && !s.bookmarks[verseKey].deleted : false));
  const toggleBookmark = useProgress((s) => s.toggleBookmark);
  const play = usePlayer((s) => s.play);
  const setSheet = usePlayer((s) => s.setSheet);
  const setReciteMode = usePlayer((s) => s.setReciteMode);
  if (!verseKey) return null;
  const { surah, ayah } = parseKey(verseKey);
  const ch = chapter(surah);
  const share = async () => {
    const url = `${location.origin}/quran/${surah}?ayah=${ayah}`;
    try { await navigator.share?.({ title: `${ch.n} ${verseKey}`, text: text ? `${text}\n\n— Qur'an ${verseKey}` : undefined, url }); } catch {}
  };
  return (
    <Sheet open onClose={onClose} title={`${ch.n} · ${verseKey}`}>
      <Section>
        <Row icon={<Play size={18} />} label="Play from this āyah" onClick={() => { void play(surah, { fromAyah: ayah }); onClose(); }} />
        <Row icon={<Repeat size={18} />} label="Repeat this āyah…" onClick={() => {
          setReciteMode(true);
          const r = useSettings.getState().settings.repeat;
          if (r.ayahRepeat < 2 && r.rangeRepeat < 2) useSettings.getState().updateDeep('repeat', { ayahRepeat: 3 });
          void play(surah, { fromAyah: ayah, toAyah: ayah });
          setSheet(true);
          onClose();
        }} />
        <Row icon={<Repeat size={18} />} label={`Repeat from here to the end of ${ch.n}…`} onClick={() => { setReciteMode(true); void play(surah, { fromAyah: ayah, toAyah: ch.v }); setSheet(true); onClose(); }} />
        <Row icon={<Repeat size={18} />} label={`Loop the whole of ${ch.n}`} onClick={() => {
          setReciteMode(true);
          useSettings.getState().updateDeep('repeat', { rangeRepeat: 0, gapMode: 'off', ayahRepeat: 1 });
          void play(surah, { fromAyah: 1 });
          setSheet(true);
          onClose();
        }} />
      </Section>
      <Section>
        <Row icon={bookmarked ? <BookmarkCheck size={18} /> : <Bookmark size={18} />} label={bookmarked ? 'Remove bookmark' : 'Bookmark'} onClick={() => { toggleBookmark(verseKey); onClose(); }} />
        {text && <Row icon={<Copy size={18} />} label="Copy text" onClick={() => { void navigator.clipboard?.writeText(`${text}\n— Qur'an ${verseKey}`); onClose(); }} />}
        {'share' in navigator && <Row icon={<Share2 size={18} />} label="Share" onClick={() => { void share(); onClose(); }} />}
      </Section>
    </Sheet>
  );
}
